<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                        :placeholder="$t('keyword')"></b-form-input>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-4">{{ $t('order') }}</div>
          <div class="col-lg-4">{{ $t('customer') }}</div>
          <div class="col-lg-3">{{ $t('info') }}</div>
          <div class="col-lg-1"></div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-4">
            <div>
              <b>{{ $t('code') }}: </b> <span>{{ item.code}}</span>
            </div>
            <div>
              <b>{{ $t('product') }}: </b> <span>{{ item.products.length }} {{$t('product').toLowerCase()}}</span>
            </div>
            <div>
              <b>{{ $t('totalAmount') }}: </b> <span>{{ calcTotalAmount(item) | numFormat }}đ</span>
            </div>
            <div>
              <span class="badge badge-danger" v-if="['failure', 'cancel', 'systemCancel', 'carrierCancel'].includes(item.status)">{{$t(item.status)}}</span>
              <span class="badge badge-success" v-else-if="['success'].includes(item.status)">{{$t(item.status)}}</span>
              <span class="badge badge-info" v-else>{{$t(item.status)}}</span>
            </div>
          </div>
          <div class="col-lg-4">
            <div>
              <b>{{ $t('name') }}: </b> <span v-if="item.customerName">{{ item.customerName }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('phone') }}: </b> <span v-if="item.customerPhone">{{ item.customerPhone }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('email') }}: </b> <span v-if="item.customerEmail">{{ item.customerEmail }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('address') }}: </b> <span v-if="item.customerAddress">{{ item.customerAddress }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
          </div>
          <div class="col-lg-3">
            <div>
              <b>{{ $t('createdBy') }}: </b> <span v-if="item.createdBy">{{ item.createdBy.name }}</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('createTime') }}: </b> <span>{{ item.createTime | moment('DD/MM/YY HH:mm') }}đ</span>
            </div>
            <div>
              <b>{{ $t('updatedBy') }}: </b> <span v-if="item.updatedBy">{{ item.updatedBy.name }}</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('updateTime') }}: </b> <span>{{ item.createTime | moment('DD/MM/YY HH:mm') }}đ</span>
            </div>
          </div>
          <div class="col-lg-1 text-center">
            <div class="c-smart-table__content">
              <div class="c-buttons clearfix is-2">
                <div class="c-buttons__col">
                  <button @click="update(item._id)" type="button"
                          class="btn btn-sm btn-info">
                    <font-awesome-icon icon="info"/>&nbsp;{{ $t('detail') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>

    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
    <b-modal size="lg" v-model="showForm" :title="$t('detail')" no-close-on-backdrop no-enforce-focus>
      <div>
        <b>{{ $t('code') }}: </b> <span>{{formModel.code}}</span>
      </div>
      <div>
        <b>{{ $t('status') }}: </b> <span>{{$t(formModel.status)}}</span>
      </div>
      <div>
        <hr class="my-2">
        <h5>{{$t('product')}}</h5>
        <table class="table w-100" >
          <thead>
          <th>{{$t('product')}}</th>
          <th>{{$t('price')}}</th>
          <th>{{$t('quantity')}}</th>
          <th>{{$t('discount')}}</th>
          <th>{{$t('sum')}}</th>
          <th v-if="formModel.type === 'store'">{{$t('quantity')}}</th>
          </thead>
          <tbody v-if="formModel.products && formModel.products.length">
          <tr v-for="(product, index) in formModel.products" :key="index">
            <td>{{product.productSku}} - {{product.productName}}</td>
            <td>{{product.price | numFormat}}đ</td>
            <td>{{product.quantity | numFormat}}</td>
            <td>{{product.discount | numFormat}}đ</td>
            <td>{{Number(product.price) * Number(product.quantity) - Number(product.discount) | numFormat}}đ</td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr><td colspan="6" class="text-center">{{$t('empty')}}</td></tr>
          </tbody>
        </table>
      </div>
      <div>
        <hr class="my-2">
        <h5 class="mb-0">{{$t('customer')}}</h5>
        <ul class="mb-2">
          <li>
            <b>{{ $t('name') }}: </b> <span v-if="formModel.customerName">{{ formModel.customerName }}</span>
            <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
          </li>
          <li>
            <b>{{ $t('phone') }}: </b> <span v-if="formModel.customerPhone">{{ formModel.customerPhone }}</span>
            <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
          </li>
          <li>
            <b>{{ $t('email') }}: </b> <span v-if="formModel.customerEmail">{{ formModel.customerEmail }}</span>
            <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
          </li>
          <li>
            <b>{{ $t('address') }}: </b> <span v-if="formModel.customerAddress">{{ formModel.customerAddress }}</span>
            <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
          </li>
          <li v-for="field in formModel.customFields" :key="field.key">
            <b>{{ field.key }}: </b> <span v-if="field.val">{{ field.val.join(', ') }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('salesPerson') }}: </b> <span v-if="formModel.user">{{ formModel.user.name }}</span>
            <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
          </li>
          <li>
            <b>{{ $t('supportingUsers') }}: </b>
            <span v-if="formModel.users && formModel.users.length"> {{ formModel.users.map(u => u.name).join(', ') }} </span>
            <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
          </li>
        </ul>
      </div>
      <div>
        <hr class="my-2">
        <h5 class="mb-0">{{$t('ship')}}</h5>
        <ul class="mb-2">
          <li>
            <b>{{ $t('carrierName') }}: </b> <span v-if="formModel.carrierName">{{ formModel.carrierName }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('carrierCode') }}: </b> <span v-if="formModel.carrierCode">{{ formModel.carrierCode }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('carrierServiceName') }}: </b> <span v-if="formModel.carrierServiceName">{{ formModel.carrierServiceName }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('shipFeeWithCarrier') }}: </b> <span v-if="formModel.shipFee">{{ formModel.shipFee| numFormat }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('codFee') }}: </b> <span v-if="formModel.codFee">{{ formModel.codFee | numFormat }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('declaredFee') }}: </b> <span v-if="formModel.declaredFee">{{ formModel.declaredFee | numFormat }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('overWeightShipFee') }}: </b> <span v-if="formModel.overWeightShipFee">{{ formModel.overWeightShipFee | numFormat }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('returnFee') }}: </b> <span v-if="formModel.returnFee">{{ formModel.returnFee | numFormat }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
        </ul>
      </div>
      <div>
        <hr class="my-2">
        <h5 class="mb-0">{{$t('pay')}}</h5>
        <ul>
          <li>
            <b>{{ $t('shipFee') }}: </b> <span v-if="formModel.customerShipFee">{{ formModel.customerShipFee | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('totalAmount') }}: </b> <span>{{ calcTotalAmount(formModel) | numFormat }}đ</span>
          </li>
          <li>
            <b>{{ $t('discountOnOrder') }}: </b> <span v-if="formModel.discountAmount">{{ formModel.discountAmount | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('depositAmount') }}: </b> <span v-if="formModel.depositAmount">{{ formModel.depositAmount | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('transferAmount') }}: </b> <span v-if="formModel.transferAmount">{{ formModel.transferAmount | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";

export default {
  props: ['client'],
  mixins: [List, CRUD],
  data: function () {
    return {
      autoLoad: true,
      service: '/product-order',
      defaultFilterFormModel: {
        client: this.client ? this.client._id : null
      }
    }
  },
  methods: {
    calcTotalAmount(item) {
      let total = 0;
      if (item.products) {
        item.products.forEach(product => {
          total += (product.quantity * product.price) - product.discount;
        })
      }
      total += item.customerShipFee;
      return total;
    },
  },
  i18n: {
    messages: {
      en: {
        order: "Đơn hàng",
        customer: "Khách hàng",
        code: "Mã đơn hàng",
        salesPerson: "NV bán hàng",
        supportingUsers: "NV hỗ trợ",
        product: "Sản phẩm",
        name: "Tên khách hàng",
        address: "Địa chỉ",
        warehouse: "Kho hàng",
        quantity: "Số lượng",
        createdBy: "Tạo bởi",
        updatedBy: "Cập nhật bởi",
        ship: "Vận chuyển",
        pay: "Thanh toán",
        carrierName: "Đơn vị vận chuyển",
        carrierCode: "Mã vận chuyển",
        carrierServiceName: "Dịch vụ vận chuyển",
        shipFeeWithCarrier: "Phí vận chuyển với hãng",
        codFee: "Thu hộ",
        declaredFee: "Phí bảo hiểm",
        overWeightShipFee: "Phí vượt cân",
        returnFee: "Phí chuyển hoàn",
        shipFee: "Phí vận chuyển",
        discountOnOrder: "Giảm giá trên đơn hàng",
        depositAmount: "Tiền đặt cọc",
        transferAmount: "Tiền chuyển khoản",
        empty: "Đơn haàng không có sản phẩm nào!",
        discount: "Khuyến mại",
        sum: "Tổng",
        totalAmount: "Tổng số tiền",
        // status
        new: "Mới",
        processing: "Đang xử lý",
        waitForConfirm: "Chờ xác nhận",
        confirming: "Đang xác nhận",
        confirmed: "Đã xác nhận",
        soldOut: "Hết hàng",
        changeWarehouse: "Chuyển kho",
        packing: "Đang đóng gói",
        packed: "Đã đóng gói",
        pickup: "Chờ thu gom",
        shipping: "Đang chuyển",
        success: "Thành công",
        failure: "Thất bại",
        refund: "Hoàn hàng",
        refunding: "Đang chuyển hoàn",
        refundConfirmed: "Xác nhận hoàn",
        refunded: "Đã chuyển hoàn",
        cancel: "Huỷ",
        customerCancel: "Khách hàng huỷ",
        systemCancel: "Hệ thống huỷ",
        carrierCancel: "HVC huỷ",
      },
      vi: {
        order: "Đơn hàng",
        customer: "Khách hàng",
        code: "Mã đơn hàng",
        salesPerson: "NV bán hàng",
        supportingUsers: "NV hỗ trợ",
        product: "Sản phẩm",
        name: "Tên khách hàng",
        address: "Địa chỉ",
        warehouse: "Kho hàng",
        quantity: "Số lượng",
        createdBy: "Tạo bởi",
        updatedBy: "Cập nhật bởi",
        ship: "Vận chuyển",
        pay: "Thanh toán",
        carrierName: "Đơn vị vận chuyển",
        carrierCode: "Mã vận chuyển",
        carrierServiceName: "Dịch vụ vận chuyển",
        shipFeeWithCarrier: "Phí vận chuyển với hãng",
        codFee: "Thu hộ",
        declaredFee: "Phí bảo hiểm",
        overWeightShipFee: "Phí vượt cân",
        returnFee: "Phí chuyển hoàn",
        shipFee: "Phí vận chuyển",
        discountOnOrder: "Giảm giá trên đơn hàng",
        depositAmount: "Tiền đặt cọc",
        transferAmount: "Tiền chuyển khoản",
        empty: "Đơn haàng không có sản phẩm nào!",
        discount: "Khuyến mại",
        sum: "Tổng",
        totalAmount: "Tổng số tiền",
        // status
        new: "Mới",
        processing: "Đang xử lý",
        waitForConfirm: "Chờ xác nhận",
        confirming: "Đang xác nhận",
        confirmed: "Đã xác nhận",
        soldOut: "Hết hàng",
        changeWarehouse: "Chuyển kho",
        packing: "Đang đóng gói",
        packed: "Đã đóng gói",
        pickup: "Chờ thu gom",
        shipping: "Đang chuyển",
        success: "Thành công",
        failure: "Thất bại",
        refund: "Hoàn hàng",
        refunding: "Đang chuyển hoàn",
        refundConfirmed: "Xác nhận hoàn",
        refunded: "Đã chuyển hoàn",
        cancel: "Huỷ",
        customerCancel: "Khách hàng huỷ",
        systemCancel: "Hệ thống huỷ",
        carrierCancel: "HVC huỷ",
      }
    }
  }
};
</script>
<style>
.desc-viewer {
  min-height: 200px;
  max-height: 500px;
  overflow: auto;
}
</style>